(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pdp-coupon-banner"] && !Shopify.designMode) return;
  try {
    (function () {
    const KEY = 'nyf:pdp-coupon';
    const ATTEMPT_KEY = 'nyf:coupon-attempt';

    function pad(n) {
      return String(n).padStart(2, '0');
    }

    function nextMidnight() {
      const end = new Date();
      end.setHours(24, 0, 0, 0);
      return end.getTime();
    }

    function parseEnd(value) {
      if (!value) return nextMidnight();
      const ms = Date.parse(value);
      if (Number.isNaN(ms)) return nextMidnight();
      return ms;
    }

    function markApplied(box) {
      const applyBtn = box.querySelector('[data-pdp-offer-apply]');
      const done = box.querySelector('[data-pdp-offer-done]');
      box.classList.add('is-applied');
      if (applyBtn) {
        applyBtn.disabled = true;
        applyBtn.textContent = box.dataset.msgApplied || 'Added';
      }
      if (done) done.hidden = false;
    }

    function markIdle(box) {
      const applyBtn = box.querySelector('[data-pdp-offer-apply]');
      const done = box.querySelector('[data-pdp-offer-done]');
      box.classList.remove('is-applied');
      if (applyBtn) {
        applyBtn.disabled = false;
        applyBtn.textContent = box.dataset.msgApply || 'Apply';
      }
      if (done) done.hidden = true;
    }

    async function applyToCart(root, code) {
      try {
        const res = await fetch(root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ discount: code }),
        });
        if (!res.ok) return false;
        const data = await res.json();
        if (data.status) return false;
        return true;
      } catch (err) {
        return false;
      }
    }

    function bindOffer(box) {
      if (!box || box.dataset.bound) return;
      box.dataset.bound = 'true';
      const hoursEl = box.querySelector('[data-h]');
      const minsEl = box.querySelector('[data-m]');
      const secsEl = box.querySelector('[data-s]');
      const applyBtn = box.querySelector('[data-pdp-offer-apply]');
      const removeBtn = box.querySelector('[data-pdp-offer-remove]');
      const timer = box.querySelector('[data-coupon-timer]');
      const info = box.closest('[data-pdp-info]');
      const code = (box.dataset.code || '').trim();
      const fixedEnd = box.dataset.endsAt;
      let endAt = parseEnd(fixedEnd);

      const tick = () => {
        let left = endAt - Date.now();
        if (left <= 0) {
          if (fixedEnd) {
            box.classList.add('is-ended');
            if (timer) timer.textContent = box.dataset.msgEnded || 'Offer ended';
            return;
          }
          endAt = nextMidnight();
          left = endAt - Date.now();
        }
        const hours = Math.floor(left / 3600000);
        const mins = Math.floor((left % 3600000) / 60000);
        const secs = Math.floor((left % 60000) / 1000);
        if (hoursEl) hoursEl.textContent = pad(hours);
        if (minsEl) minsEl.textContent = pad(mins);
        if (secsEl) secsEl.textContent = pad(secs);
      };

      tick();
      window.setInterval(tick, 1000);

      let stored = '';
      try {
        stored = (sessionStorage.getItem(KEY) || '').trim().toUpperCase();
      } catch (err) {
        stored = '';
      }
      if (code && stored === code.toUpperCase()) {
        if (info) info.dataset.couponApplied = 'true';
        markApplied(box);
        try {
          if (!sessionStorage.getItem('nyf:pdp-coupon-percent')) {
            sessionStorage.setItem(
              'nyf:pdp-coupon-percent',
              (info && info.dataset.offerPercent) || box.dataset.percent || '20'
            );
          }
        } catch (err) {
          /* ignore */
        }
      }

      if (applyBtn) {
        applyBtn.addEventListener('click', async () => {
          if (!code || box.classList.contains('is-applied')) return;
          applyBtn.disabled = true;
          applyBtn.textContent = box.dataset.msgApplying || 'Applying coupon…';
          const percent = (info && info.dataset.offerPercent) || box.dataset.percent || '20';
          try {
            sessionStorage.setItem(KEY, code);
            sessionStorage.setItem('nyf:pdp-coupon-percent', String(percent));
            sessionStorage.setItem(ATTEMPT_KEY, code);
          } catch (err) {
            /* ignore */
          }
          if (info) {
            info.dataset.couponApplied = 'true';
            info.dispatchEvent(new CustomEvent('nyf:coupon-applied', { bubbles: true }));
          }
          markApplied(box);
          if (window.nyfCoupon && typeof window.nyfCoupon.paint === 'function') {
            window.nyfCoupon.paint(document);
          }
          const root = box.dataset.root || '/';
          await applyToCart(root, code);
          if (window.nyfCoupon && typeof window.nyfCoupon.paint === 'function') {
            window.nyfCoupon.paint(document);
          }
        });
      }

      if (removeBtn) {
        removeBtn.addEventListener('click', async () => {
          if (window.nyfCoupon && typeof window.nyfCoupon.clear === 'function') {
            window.nyfCoupon.clear();
          }
          if (info) {
            info.dataset.couponApplied = 'false';
            info.dispatchEvent(new CustomEvent('nyf:coupon-removed', { bubbles: true }));
          }
          markIdle(box);
          const root = box.dataset.root || '/';
          await applyToCart(root, '');
          const drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.refresh === 'function') drawer.refresh();
        });
      }
    }

    document.querySelectorAll('[data-pdp-offer]').forEach(bindOffer);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    class CardGallery extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      this.track = this.querySelector('[data-track]');
      this.slides = Array.from(this.querySelectorAll('[data-card-slide]')).slice(0, 3);
      this.dotsHost = this.querySelector('[data-dots]');
      this.href = this.getAttribute('data-href');
      if (!this.track || this.slides.length < 2) return;

      this.dotsHost.replaceChildren();
      this.dots = this.slides.map((_, i) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'card-gallery__dot';
        btn.setAttribute('aria-label', String(i + 1));
        btn.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.go(i);
        });
        this.dotsHost.appendChild(btn);
        return btn;
      });

      this.track.addEventListener('scroll', () => this.sync(), { passive: true });
      this.track.addEventListener('pointerdown', (event) => this.onPointerDown(event));
      this.track.addEventListener('pointermove', (event) => this.onPointerMove(event));
      this.track.addEventListener('pointerup', (event) => this.onPointerUp(event));
      this.track.addEventListener('pointercancel', (event) => this.onPointerUp(event));
      this.track.addEventListener('click', (event) => this.onClick(event));
      this.addEventListener('mouseenter', () => this.pause());
      this.addEventListener('mouseleave', () => this.play());
      this.addEventListener('focusin', () => this.pause());
      this.addEventListener('focusout', () => this.play());

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) this.play();
            else this.pause();
          });
        },
        { threshold: 0.55 }
      );
      this.observer.observe(this);
      this.sync();
    }

    disconnectedCallback() {
      this.pause();
      if (this.observer) this.observer.disconnect();
    }

    slideWidth() {
      return this.slides[0] ? this.slides[0].getBoundingClientRect().width : 0;
    }

    currentIndex() {
      const width = this.slideWidth();
      if (!width) return 0;
      return Math.round(this.track.scrollLeft / width);
    }

    go(index) {
      const width = this.slideWidth();
      const max = this.slides.length - 1;
      const next = Math.max(0, Math.min(max, index));
      this.track.scrollTo({ left: next * width, behavior: 'smooth' });
    }

    sync() {
      const index = this.currentIndex();
      this.dots.forEach((dot, i) => dot.classList.toggle('is-on', i === index));
    }

    play() {
      this.pause();
      this.timer = window.setInterval(() => {
        const next = this.currentIndex() + 1;
        this.go(next >= this.slides.length ? 0 : next);
      }, 3400);
    }

    pause() {
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    }

    onPointerDown(event) {
      this.startX = event.clientX;
      this.startY = event.clientY;
      this.moved = false;
      this.axis = null;
      this.pause();
    }

    onPointerMove(event) {
      if (this.startX == null) return;
      const dx = event.clientX - this.startX;
      const dy = event.clientY - this.startY;
      if (this.axis == null && (Math.abs(dx) > 8 || Math.abs(dy) > 8)) {
        this.axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
      }
      if (this.axis === 'x') this.moved = true;
    }

    onPointerUp(event) {
      if (this.axis === 'x' && this.startX != null) {
        const dx = event.clientX - this.startX;
        if (dx <= -40) this.go(this.currentIndex() + 1);
        else if (dx >= 40) this.go(this.currentIndex() - 1);
      }
      this.startX = null;
      this.startY = null;
      this.axis = null;
      this.play();
    }

    onClick(event) {
      if (this.moved) {
        event.preventDefault();
        event.stopPropagation();
        this.moved = false;
        return;
      }
      if (this.href) window.location.href = this.href;
    }
  }

  if (!customElements.get('card-gallery')) {
    customElements.define('card-gallery', CardGallery);
  }
  } catch(e) { console.error(e); }
})();

})();
